import axios from 'axios/index'

import config from '../../config'
import action, { actionFailed } from '../../util/action'
import createAsyncConst from '../../util/createAsyncConst'

export const REMOVE_SERVICE_CATEGORY = createAsyncConst(
  'REMOVE_SERVICE_CATEGORY'
)
export const SUBMIT_SERVICE_CATEGORY = createAsyncConst(
  'SUBMIT_SERVICE_CATEGORY'
)
export const FETCH_SERVICE_CATEGORY = createAsyncConst('FETCH_SERVICE_CATEGORY')
export const EDIT_SERVICE_CATEGORY = createAsyncConst('EDIT_SERVICE_CATEGORY')
export const UPDATE_ACTIVE_TO_ORCAMENT_CATEGORY = createAsyncConst(
  'UPDATE_ACTIVE_TO_ORCAMENT_CATEGORY'
)

export function fetchServiceCategory(filters = {}) {
  return dispatch => {
    dispatch(action(FETCH_SERVICE_CATEGORY.ACTION))
    return axios
      .get(`${config.API_URL}/v2/service-category`, {
        params: filters,
      })
      .then(resp => {
        dispatch(action(FETCH_SERVICE_CATEGORY.SUCCESS, resp.data))
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_SERVICE_CATEGORY, e)))
  }
}

export async function show(id) {
  const resp = await axios.get(`${config.API_URL}/service-category/${id}`)

  return resp?.data
}

export function edit(id) {
  return dispatch => {
    dispatch(action(EDIT_SERVICE_CATEGORY.ACTION, { id }))
    return axios
      .get(`${config.API_URL}/service-category/${id}`)
      .then(resp => {
        return resp.data.data
      })
      .then(data => dispatch(action(EDIT_SERVICE_CATEGORY.SUCCESS, data)))
      .catch(e => dispatch(actionFailed(EDIT_SERVICE_CATEGORY, e)))
  }
}

function submit(values, method) {
  const id = values.id ? `/${values.id}` : ''

  return dispatch => {
    dispatch(action(SUBMIT_SERVICE_CATEGORY.ACTION))
    return axios[method](`${config.API_URL}/service-category${id}`, values)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(SUBMIT_SERVICE_CATEGORY.SUCCESS, data))
        return data
      })
      .catch(e => dispatch(actionFailed(SUBMIT_SERVICE_CATEGORY, e)))
  }
}

export function post(values) {
  return submit(values, 'post')
}

export function update(values) {
  return submit(values, 'put')
}

export function updateActiveToOrcament(id, active_to_orcament) {
  return dispatch => {
    dispatch(action(UPDATE_ACTIVE_TO_ORCAMENT_CATEGORY.ACTION))
    return axios
      .patch(`${config.API_URL}/service-category/${id}/active-to-orcament`, {
        active_to_orcament,
      })
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(UPDATE_ACTIVE_TO_ORCAMENT_CATEGORY.SUCCESS, data))
        return data
      })
      .catch(e => dispatch(actionFailed(UPDATE_ACTIVE_TO_ORCAMENT_CATEGORY, e)))
  }
}

export function remove(id) {
  return dispatch => {
    dispatch(action(REMOVE_SERVICE_CATEGORY.ACTION))
    return axios
      .delete(`${config.API_URL}/service-category/${id}`)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(REMOVE_SERVICE_CATEGORY.SUCCESS, data))
      })
      .catch(e => dispatch(actionFailed(REMOVE_SERVICE_CATEGORY, e)))
  }
}
